"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDownCircleOutline = _interopRequireDefault(require("./IconArrowDownCircleOutline"));
var IconArrowRightCircleOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDownCircleOutline.default).withConfig({
  displayName: "IconArrowRightCircleOutline",
  componentId: "c11n-8-107-0__sc-8q6lgo-0"
})(["transform:rotate(270deg);"]);
var _default = IconArrowRightCircleOutline;
exports.default = _default;